import React from "react";
import { Input, Button, Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";
import { FaCheckCircle, FaFileInvoice, FaCalendarAlt, FaDownload, FaFilter } from "react-icons/fa";

const InvoiceFilters = ({
  search,
  setSearch,
  status,
  setStatus,
  type,
  setType,
  dateRange,
  setDateRange,
  showCustomRange,
  setShowCustomRange,
  customStartDate,
  setCustomStartDate,
  customEndDate,
  setCustomEndDate,
  exportDropdownOpen,
  setExportDropdownOpen,
  handleExportCSV,
  clearFilters
}) => {
  return (
    <>
      <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-3">
        <div className="flex-grow-1" style={{ maxWidth: "190px" }}>
          <Input
            type="text"
            placeholder="🔍 Search ID, Customer, Service..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>
        <div className="d-flex flex-wrap gap-2">
          <div className="position-relative">
            <FaCheckCircle className="position-absolute" style={{ left: '8px', top: '50%', transform: 'translateY(-50%)', zIndex: 1, color: '#6c757d' }} />
            <Input
              type="select"
              value={status}
              onChange={(e) => setStatus(e.target.value)}
              style={{ width: "140px", paddingLeft: '30px' }}
            >
              <option value="all">All Statuses</option>
              <option value="paid">Paid</option>
              <option value="pending">Pending</option>
              <option value="overdue">Overdue</option>
              <option value="cancelled">Cancelled</option>
            </Input>
          </div>
          <div className="position-relative">
            <FaFileInvoice className="position-absolute" style={{ left: '8px', top: '50%', transform: 'translateY(-50%)', zIndex: 1, color: '#6c757d' }} />
            <Input
              type="select"
              value={type}
              onChange={(e) => setType(e.target.value)}
              style={{ width: "140px", paddingLeft: '30px' }}
            >
              <option value="all">All Types</option>
              <option value="booking">Booking</option>
              <option value="service">Service</option>
              <option value="package">Package</option>
            </Input>
          </div>
          <div className="position-relative">
            <FaCalendarAlt className="position-absolute" style={{ left: '8px', top: '50%', transform: 'translateY(-50%)', zIndex: 1, color: '#6c757d' }} />
            <Input
              type="select"
              value={dateRange}
              onChange={(e) => {
                setDateRange(e.target.value);
                setShowCustomRange(e.target.value === "custom");
              }}
              style={{ width: "140px", paddingLeft: '30px' }}
            >
              <option value="all">All Time</option>
              <option value="today">Today</option>
              <option value="week">This Week</option>
              <option value="month">This Month</option>
              <option value="custom">Custom Range</option>
            </Input>
          </div>
          <Dropdown
            isOpen={exportDropdownOpen}
            toggle={() => setExportDropdownOpen(!exportDropdownOpen)}
          >
            <DropdownToggle className="btn btn-outline-secondary text-white">
              <FaDownload className="me-1" />
              Export
            </DropdownToggle>
            <DropdownMenu>
              <DropdownItem onClick={handleExportCSV}>
                Export CSV
              </DropdownItem>
            </DropdownMenu>
          </Dropdown>
          <Button className="btn btn-outline-danger" onClick={clearFilters}>
            <FaFilter className="me-1" />
            Clear Filters
          </Button>
        </div>
      </div>
      
      {showCustomRange && (
        <div className="d-flex align-items-center gap-2 mb-3 p-3 bg-light rounded">
          <label className="fw-bold mb-0">From:</label>
          <Input
            type="date"
            value={customStartDate}
            onChange={(e) => setCustomStartDate(e.target.value)}
            style={{ width: "150px" }}
          />
          <label className="fw-bold mb-0">To:</label>
          <Input
            type="date"
            value={customEndDate}
            onChange={(e) => setCustomEndDate(e.target.value)}
            style={{ width: "150px" }}
          />
        </div>
      )}
    </>
  );
};

export default InvoiceFilters;